import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { map } from 'rxjs/operators';
import { AppPaths } from 'src/enums/app-paths';
import { LogService } from '../shared/log.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private authService: AuthService, private router: Router, private logger: LogService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    this.logger.log('AuthGuard#canActivate called');

    let username = sessionStorage.getItem('username');
    if(username) {
      //Se entro qui è perché ho ricaricato la pagina
      this.logger.log('AuthGuard#retrieving user auth session');
      await this.authService.retrieveAuth(username).toPromise();
      this.logger.log('AuthGuard#retrieved user auth session');
      this.authService.startUserPolling();
      this.authService.startUserActivityPolling();
    }

    if(this.authService.getCurrentUser()){
      if(this.authService.isPasswordExpired()){
        this.logger.log('PasswordExpiredGuard#password expired... redirect to reset password page');
        return this.router.parseUrl(`/${AppPaths.Auth}/${AppPaths.PasswordModify}`);
      } else {
        return true;
      }
    } else {
      this.logger.log('AuthGuard#user not logged... redirect to auth page');
      return this.router.parseUrl(`/${AppPaths.Auth}`);
    }
  }

}
